import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const PersonSchema = withDefaults({
  type: 'person',
  objectExtensions: ['person'],
  fields: [
    {
      kind: 'attribute',
      name: 'firstName',
    },
    {
      kind: 'attribute',
      name: 'lastName',
    },
    {
      kind: 'attribute',
      name: 'preferences',
    },
    {
      kind: 'attribute',
      name: 'locale',
    },
    {
      kind: 'attribute',
      name: 'accountReceivingContributionsId',
    },
    {
      kind: 'attribute',
      name: 'primaryEmailAddressId',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'belongsTo',
      name: 'user',
      type: 'user',
      options: {
        async: false,
        inverse: 'person',
      },
    },
    {
      kind: 'hasMany',
      name: 'accounts',
      type: 'account',
      options: {
        async: false,
        inverse: 'person',
      },
    },
    {
      kind: 'hasMany',
      name: 'emailAddresses',
      type: 'email-address',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'employees',
      type: 'employee',
      options: {
        async: false,
        inverse: 'person',
      },
    },
    {
      kind: 'hasMany',
      name: 'phoneNumbers',
      type: 'phone-number',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'postalAddresses',
      type: 'postal-address',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'ownedPostalAddresses',
      type: 'postal-address',
      options: {
        async: false,
        inverse: 'postalAddressable',
        as: 'postal-addressable',
      },
    },
    {
      kind: 'hasMany',
      name: 'strategyFinderResults',
      type: 'strategy-finder-result',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'messages',
      type: 'message',
      options: {
        async: false,
        inverse: 'person',
      },
    },
    {
      kind: 'hasMany',
      name: 'accountTransactions',
      type: 'account-transaction',
      options: {
        async: false,
        inverse: 'person',
      },
    },
    {
      kind: 'hasMany',
      name: 'observableDocuments',
      type: 'observable-document',
      options: {
        async: false,
        inverse: 'person',
      },
    },
  ],
});

export default PersonSchema;
